import { BigFloat } from '@1inch-community/core/math';
import { RateSource, } from '@1inch-community/models';
import { Address as FusionAddress, NetworkEnum, OrderStatus, } from '@1inch/fusion-sdk';
import { getWrapperNativeToken, isNativeToken } from '../../chain';
import { FusionQuoteMapper } from '../../one-inch-dev-portal/sdk';
export class SwapContextFusionStrategy {
    constructor(chainSdk, amountDataSource, settings) {
        this.chainSdk = chainSdk;
        this.amountDataSource = amountDataSource;
        this.settings = settings;
    }
    async supportSwap(pair, address) {
        return (address !== null &&
            pair.destination.chainId === pair.source.chainId &&
            NetworkEnum[pair.source.chainId] !== undefined);
    }
    async swap(swapSnapshot) {
        const { sourceToken, destinationToken, sourceTokenAmount, rawResponseData, walletAddress } = swapSnapshot;
        if (walletAddress === null) {
            throw new Error('Wallet not connected');
        }
        if (!rawResponseData) {
            throw new Error('');
        }
        const sdk = await this.chainSdk.getInstance(swapSnapshot.sourceToken.chainId);
        const quote = FusionQuoteMapper.toDomain(rawResponseData);
        if (!quote.quoteId) {
            throw new Error('quoter has not returned quoteId');
        }
        const orderParams = {
            walletAddress,
            fromTokenAddress: sourceToken.address,
            toTokenAddress: destinationToken.address,
            amount: sourceTokenAmount.toString(),
            preset: rawResponseData.response.recommended_preset,
        };
        const order = await quote.createFusionOrder({
            receiver: orderParams.receiver ? new FusionAddress(orderParams.receiver) : undefined,
            preset: orderParams.preset,
            nonce: orderParams.nonce,
            allowPartialFills: orderParams.allowPartialFills,
            allowMultipleFills: orderParams.allowMultipleFills,
            orderExpirationDelay: orderParams.orderExpirationDelay,
            network: swapSnapshot.sourceToken.chainId.valueOf(),
        });
        const info = await sdk.submitOrder(order, quote.quoteId);
        await this.checkOrderStatus(sdk, info.orderHash);
        return info.orderHash;
    }
    async getDataSnapshot(pair, sourceTokenAmount, walletAddress) {
        let sourceToken = pair.source;
        const destinationToken = pair.destination;
        const chainId = sourceToken.chainId;
        if (sourceTokenAmount.isZero() || !walletAddress) {
            throw new Error('');
        }
        const isSupportExchange = await this.supportSwap({
            source: sourceToken,
            destination: destinationToken,
        }, walletAddress);
        if (!isSupportExchange) {
            throw new Error(`Strategy ${SwapContextFusionStrategy.name} not support exchange by presented pair/chain`);
        }
        const sdk = await this.chainSdk.getInstance(chainId);
        const balance = await this.amountDataSource.getMaxAmount();
        if (balance < sourceTokenAmount) {
            throw new Error('');
        }
        if (isNativeToken(sourceToken.address)) {
            sourceToken = getWrapperNativeToken(chainId);
        }
        const orderParams = {
            walletAddress: walletAddress.toString(),
            fromTokenAddress: sourceToken.address,
            toTokenAddress: destinationToken.address,
            amount: sourceTokenAmount.toBigInt(sourceToken.decimals).toString(),
        };
        const quote = await sdk.getQuote(orderParams);
        if (quote === null) {
            throw new Error('');
        }
        const recommendedPreset = quote.recommendedPreset;
        const preset = quote.getPreset(recommendedPreset);
        const autoSlippage = 1;
        const marketPrice = BigFloat.fromBigInt(BigInt(quote.toTokenAmount), destinationToken.decimals);
        const rate = marketPrice.div(sourceTokenAmount);
        const revertedRate = sourceTokenAmount.div(marketPrice);
        const rateData = {
            source: RateSource.fusion,
            rate,
            revertedRate,
            isReverted: false,
            sourceToken: sourceToken,
            destinationToken: destinationToken,
        };
        const slippageSettings = this.settings.slippage;
        let minReceive = BigFloat.fromBigInt(preset.auctionEndAmount, destinationToken.decimals);
        if (slippageSettings.value !== null) {
            const [slippage] = slippageSettings.value;
            const percentAmount = BigFloat.from(slippage).mul(marketPrice).div(BigFloat.from(100));
            minReceive = marketPrice.sub(percentAmount);
        }
        return {
            walletAddress,
            sourceToken,
            destinationToken,
            sourceTokenAmount,
            minReceive,
            destinationTokenAmount: marketPrice,
            autoAuctionTime: Number(preset.auctionDuration),
            autoSlippage: autoSlippage,
            rate: rateData,
            rawResponseData: FusionQuoteMapper.toDto(orderParams, quote),
        };
    }
    async checkOrderStatus(sdk, orderHash) {
        let statusResponse;
        while (true) {
            try {
                statusResponse = await sdk.getOrderStatus(orderHash);
            }
            catch (e) {
                statusResponse = undefined;
                console.warn(e);
            }
            if (!statusResponse ||
                statusResponse.status === OrderStatus.Pending ||
                statusResponse.status === OrderStatus.PartiallyFilled) {
                await new Promise((resolve) => setTimeout(() => resolve(undefined), 1000));
            }
            else if (statusResponse.status === OrderStatus.Filled) {
                break;
            }
            else {
                throw new Error(`Order break by ${statusResponse.status} reason`);
            }
        }
    }
}
//# sourceMappingURL=swap-context-fusion.strategy.js.map